// assets/recently-viewed.js
// Add 20250526 Section: Recently Viewed Products Slider
// Fix Wishlist & Add to Cart Icons 20250617 call

document.addEventListener("DOMContentLoaded", function () {
 // const rvWrapper = document.getElementById("recently-viewed-wrapper"); 
 const rvWrapper =
    document.querySelector("[data-recently-viewed]") ||
    document.getElementById("recently-viewed-wrapper"); //show colletion custom

  //const rvCarousel = document.getElementById("recently-viewed-carousel");
 // const rvShowMoreBtn = document.getElementById("rv-show-more-button");
 // const rvHandles = JSON.parse(localStorage.getItem("recently_viewed")) || [];

  //if (!rvHandles.length || !rvWrapper) return;
  //rvWrapper.style.display = "block";
 if (!rvWrapper) return;

  const rvCarousel = rvWrapper.querySelector("#recently-viewed-carousel");
  const rvShowMoreBtn = rvWrapper.querySelector("#rv-show-more-button");

  const rvHandles = JSON.parse(
    localStorage.getItem("recently_viewed") || "[]"
  );

  if (!rvHandles.length || !rvCarousel) return;

  rvWrapper.style.display = "block";



  // Responsive maxInitial
  let maxInitial = 6;
  if (window.innerWidth < 480) {
    maxInitial = 2;
  } else if (window.innerWidth < 768) {
    maxInitial = 3;
  } else if (window.innerWidth < 1024) {
    maxInitial = 4;
  }

  // Declare private Flickity options to reuse on reload
  const flickityOptions = {
    cellAlign: "left",
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
    autoPlay: window.innerWidth >= 768 ? 3000 : false,
    pauseAutoPlayOnHover: true,
    selectedAttraction: 0.015,
    friction: 0.25,
    draggable: true,
    touchVerticalScroll: false,
  };

  let flkty;

  Promise.all(
    rvHandles.map((handle) =>
      fetch(`/products/${handle}?section_id=product-card`)
        .then((res) => res.text())
        .then((html) => {
          const tmp = document.createElement("div");
          tmp.innerHTML = html.trim();
          return tmp.querySelector(".carousel-cell");
        })
        .catch(() => null)
    )
  ).then((cards) => {
    cards = cards.filter(Boolean);

    cards.forEach((card, i) => {
      if (i < maxInitial) {
        rvCarousel.appendChild(card);
      } else {
        card.classList.add("rv-hidden-product");
        card.dataset.rvHidden = "true";
      }
    });

    // Initialize wishlist icon and add to cart
    if (window.shopEnhancer?.initWishlistIcons) {
      window.shopEnhancer.initWishlistIcons(rvCarousel);
    }
    if (window.shopEnhancer?.initQuickAddIcons) {
      window.shopEnhancer.initQuickAddIcons(rvCarousel);
    }

    // Initialize Flickity slider
    flkty = new Flickity(rvCarousel, flickityOptions);

    // Handling the Show more button
    if (cards.length > maxInitial) {
      rvShowMoreBtn.style.display = "inline-block";
      let expanded = false;

      rvShowMoreBtn.addEventListener("click", () => {
        expanded = !expanded;

        if (expanded) {
          document.querySelectorAll('[data-rv-hidden="true"]').forEach((el) => {
            el.classList.remove("rv-hidden-product");
            el.removeAttribute("data-rv-hidden");
            rvCarousel.appendChild(el);
            flkty.append(el);
          });
        } else {
          // Collapse: destroy old slider and re-render
          flkty.destroy();
          rvCarousel.innerHTML = "";
          cards.forEach((card, i) => {
            if (i < maxInitial) {
              rvCarousel.appendChild(card);
            } else {
              card.classList.add("rv-hidden-product");
              card.dataset.rvHidden = "true";
            }
          });

          // Re-init Flickity
          flkty = new Flickity(rvCarousel, flickityOptions);

          // Re-initialize icons after re-rendering DOM
          if (window.shopEnhancer?.initWishlistIcons) {
            window.shopEnhancer.initWishlistIcons(rvCarousel);
          }
          if (window.shopEnhancer?.initQuickAddIcons) {
            window.shopEnhancer.initQuickAddIcons(rvCarousel);
          }
        }

        flkty.reloadCells();
        flkty.resize();
        rvShowMoreBtn.textContent = expanded ? "Show less" : "Show more";
      });
    }
  });
});






// assets/recently-viewed.js
// Add 20250526 Section: Recently Viewed Products Slider
//Fix  Wishlist & Add to Cart Icons 20250617 call

/*
document.addEventListener("DOMContentLoaded", function () {
  const rvWrapper = document.getElementById("recently-viewed-wrapper");
  const rvCarousel = document.getElementById("recently-viewed-carousel");
  const rvShowMoreBtn = document.getElementById("rv-show-more-button");
  const rvHandles = JSON.parse(localStorage.getItem("recently_viewed")) || [];

  if (!rvHandles.length || !rvWrapper) return;
  rvWrapper.style.display = "block";

  // Responsive maxInitial
  let maxInitial = 6;
  if (window.innerWidth < 480) {
    maxInitial = 2;
  } else if (window.innerWidth < 768) {
    maxInitial = 3;
  } else if (window.innerWidth < 1024) {
    maxInitial = 4;
  }

  Promise.all(
    rvHandles.map((handle) =>
     // fetch(/products/${handle}?section_id=product-card)
      fetch(`/products/${handle}?section_id=product-card`)
        .then((res) => res.text())
        .then((html) => {
          const tmp = document.createElement("div");
          tmp.innerHTML = html.trim();
          return tmp.querySelector(".carousel-cell");
        })
        .catch(() => null)
    )
  ).then((cards) => {
    cards = cards.filter(Boolean);
    console.log("Fetched cards:", cards);
    cards.forEach((card, i) => {
      if (i >= maxInitial) card.classList.add("rv-hidden-product");
      rvCarousel.appendChild(card);
           
    });
        //Called only once after all cards have been appended
        // Fix wishlist icon call , it need init 
            if (window.shopEnhancer?.initWishlistIcons) {
            window.shopEnhancer.initWishlistIcons(rvCarousel);
           }
            //load icon cart
             if (window.shopEnhancer?.initQuickAddIcons) {
            window.shopEnhancer.initQuickAddIcons(rvCarousel);
           }     

    const flkty = new Flickity(rvCarousel, {
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: true,
     // groupCells: true,
      autoPlay: window.innerWidth >= 768 ? 3000 : false,
      pauseAutoPlayOnHover: true,
      selectedAttraction: 0.015,
      friction: 0.25,
      draggable: true, // ✨ Important for iOS touch
      touchVerticalScroll: false //block vertical scroll when swiping horizontally
    });

    if (cards.length > maxInitial) {
      rvShowMoreBtn.style.display = "inline-block";
      let expanded = false;

      rvShowMoreBtn.addEventListener("click", () => {
        expanded = !expanded;
        document.querySelectorAll(".rv-hidden-product").forEach((el) => {
          el.classList.toggle("rv-hidden-product", !expanded);
        });
        flkty.reloadCells();
        rvShowMoreBtn.textContent = expanded ? "Show less" : "Show more";
      });
    }
  });
});
*/
/*
// Fix  Wishlist & Add to Cart Icons  in <a>
document.addEventListener("click", function (e) {
  //If the user clicks the wishlist or add-to-cart button in Recently Viewed
  if (
    e.target.closest(".add-to-wishlist") ||
    e.target.closest(".add-to-cart_new")
  ) {
    e.preventDefault();
    e.stopPropagation();
  }
}); */